import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSheetInterface,
  Creature,
  CreatureInstance,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";
// import DataUtilities from '../../../utilities/common_utilities';

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import SelectCreatureBox from "@dndComponents/select/SelectCreatureBox";
import ButtonBox from "@components/input/buttons/ButtonBox";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();
// const common_util = DataUtilities.getInstance();

export default function CharacterMinionsButton({ 
  character,
  char_interface,
  disabled,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false);
  const [custom_minion, setCustomMinion] = useState<Creature | null>(null);

  const renderCustomMinionSelect = () => {
    return (
      <div style={{ 
        height: "100%",
        overflowX: "hidden"
      }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectCreatureBox
              name="Select a Creature"
              value={custom_minion?._id??""}
              onChangeObject={setCustomMinion}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <ButtonBox
              name="Add"
              disabled={custom_minion === null}
              onClick={ async () => {
                if (custom_minion) {
                  const creature_instance = new CreatureInstance();
                  await creature_instance.copyCreature(custom_minion);
                  
                  character.minions.push(creature_instance);
                  onChange();
                  setOpen(false);
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}
        size={{
          xs: 12
        }}>
        Minions
      </Grid>
      <ModalOrDrawer
        open={ open } 
        // drawer_only
        onClose={() => {
          setOpen(false);
          setCustomMinion(null);
          character.subscription_holder.modalClosed();
        }}>
        { open && renderCustomMinionSelect() }
      </ModalOrDrawer>
    </Grid>
  );
}
